<template>
  <div class="page-content animate__animated animate__fadeIn">
    <div class="border-bottom" style="margin-top:0;">
      <!-- 顶部搜索框 -->
      <div>
        <el-form :inline="true" :model="queryParams" class="demo-form-inline">
          <el-form-item label="文档名称">
            <el-input v-model="queryParams.componentName" placeholder="请输入文档名称进行查询" class="form-item-width"
              clearable></el-input>
          </el-form-item>
          <el-form-item class="right-btns">
            <el-button type="primary" @click="onSearch">查询</el-button>
            <el-button type="warning" @click="onReset">重置</el-button>
            <el-button type="primary" @click="handlecomponentAdd">新增</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="margin-top" style="margin-bottom:0;margin-top:15px">
      <!-- 表格组件 -->
      <el-table :data="tableData" stripe border row-key="deptId" default-expand-all :tree-props="{ children: 'children' }"
        :header-cell-style="{ background: '#aef1f6', color: '#606266' }">
        <!-- 序号列 -->
        <el-table-column align="center" type="index" label="序号" width="50"></el-table-column>
        <!-- 动态生成其他列 -->
        <el-table-column align="center" v-for="tab in tableTitle" :key="tab.code" :label="tab.name"
          show-overflow-tooltip :width="tab.width">
          <template slot-scope="scope">
            <!-- 针对 status 列的特殊处理 -->
            <span v-if="tab.code === 'status'"
              :style="scope.row.status === '0' ? { color: 'green' } : { color: 'red' }">{{ scope.row.status === '0' ?
              '正常' : '停用' }}</span>
            <span v-else>{{ scope.row[tab.code] }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="updateData(scope.row)" class="update-btn">修改</el-button>
            <el-button style="color:red" type="text" @click="deleteData(scope.row)" class="update-btn">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <div>
        <Pagination :total="pageParams.total" :page="pageParams.pageNum" :limit="pageParams.pageSize"
          @pagination="onChangePages" />
      </div>
    </div>
    <!-- 添加 修改角色 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisble" width="30%" @close="handleDialogClose">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="文档名称" prop="componentName">
          <el-input maxlength="7" show-word-limit v-model="form.componentName" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="装置" prop="apparatusId">
          <el-select v-model="form.apparatusId" placeholder="请选择装置">
            <el-option v-for="item in apparatusList" :key="item.apparatusId" :label="item.apparatusName"
              :value="item.apparatusId"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm('form')">{{ dialogTitle === '新增' ? '立即添加' : '立即修改' }}</el-button>
        <el-button @click="resetForm('form')">重置</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import {
  getComponentList,
  componentAdd,
  componentById,
  updeteComponent,
  deleteComponent
} from "@/api/data-service/unit.js";
import { getApparatusAll } from "@/api/data-service/apparatus.js";
export default {
  components: {
    Pagination
  },
  data() {
    return {
      form: {
        componentName: "", //文档名称
        apparatusId: "", //
        // delFlag: "0" //
      },
      rules: {
        componentName: [
          { required: true, message: "请填写文档名称", trigger: "blur" }
        ],
        apparatusId: [
          { required: true, message: "请选择装置", trigger: "change" }
        ]
      },
      dialogTitle: "",
      updateId: "", //修改数据需要的id
      dialogFormVisble: false,
      // 表格数据
      tableData: [],
      // 表格标题数组
      tableTitle: [
        { name: "文档名称", code: "componentName", width: "" },
        { name: "装置", code: "apparatusName", width: "" }
      ],

      pageParams: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      queryParams: {
        orderByColumn: "",
        isAsc: "",
        componentName: "",
        orderBy: ""
      },
      apparatusList: []
    };
  },
  mounted() {
    this.onGetDataList();
    this.queryApparatusList();
  },

  methods: {
    queryApparatusList() {
      getApparatusAll({
        orderByColumn: "",
        isAsc: "",
        apparatusName: "",
        orderBy: "",
        // delFlag: "0", // ?
        ...this.pageParams
      }).then(res => {
        this.apparatusList = res?.data || [];
      });
    },
    addData() {
      this.dialogTitle = "新增";
      this.dialogFormVisble = true;
    },
    // 增 / 改
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.dialogTitle === "新增") {
            componentAdd(this.form).then(res => {
              if (res.data) {
                this.$message.success(res.msg || "新增成功！");
                this.dialogFormVisble = false;
                this.onGetDataList();
              }
            });
          } else {
            updeteComponent({
              ...this.form,
              componentId: this.updateId
            }).then(r => {
              if (r.data) {
                this.$message.success(r.msg || "修改成功！");
                this.dialogFormVisble = false;
                this.onGetDataList();
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 删
    deleteData(row) {
      this.$confirm(`提示，确定要删除该条数据吗？`, {
        title: "提示",
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deleteComponent({ ids: [row.componentId] }).then(res => {
            if (res?.data) {
              this.$message.success(res.msg || "删除成功");
              this.onGetDataList();
            }
          });
        })
        .catch(error => {
          console.log(error);
          // 取消删除时显示提示
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 改
    updateData(row) {
      this.dialogTitle = "修改";
      this.dialogFormVisble = true;
      this.updateId = row.componentId;
      componentById({ id: row.componentId }).then(res => {
        const { componentName, apparatusId } = res.data;
        this.form.componentName = componentName;
        this.form.apparatusId = apparatusId;
      });
    },
    // 查
    onGetDataList() {
      getComponentList({
        ...this.queryParams,
        ...this.pageParams
      }).then(res => {
        const { records, total } = res.data;
        this.tableData = records;
        this.pageParams.total = total;
      });
    },

    handlecomponentAdd() {
      this.dialogTitle = "新增";
      this.dialogFormVisble = true;
    },
    handleDialogClose() {
      this.resetForm("form");
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 查询
    onSearch() {
      this.onGetDataList();
    },
    // 重置
    onReset() {
      this.pageParams.pageNum = 1
      this.pageParams.pageSize = 10
      this.queryParams.componentName = "";
      this.onSearch();
    },
    // 分页方法
    onChangePages(pageInfo) {
      this.pageParams.pageNum = pageInfo.page;
      this.pageParams.pageSize = pageInfo.limit;
      this.onGetDataList();
    }
  }
};
</script>
<style lang="less" scoped>
.analyse-container {
  display: flex;
  height: 95vh;
}

.form-item-width {
  width: 250px;
}

.right-btns {
  position: absolute;
  right: 20px !important;
}

.border-bottom {
  border-bottom: 1px solid #e2e2e4;
}

.margin-top {
  margin-top: -15px;
}

.custom-tree-node {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;

  .tree-node-label {
    font-size: 12px;
    font-weight: bold;
  }
}
</style>
